//we set GPTSearchReport as raw link, because its respond takes too long than api gateway allows

const apiURL = {
    getCompanies: `${process.env.REACT_APP_BASE_URL}/company`,
    getCompanyData: `${process.env.REACT_APP_BASE_URL}/company-data`,
    saveCompanyData: `${process.env.REACT_APP_BASE_URL}/company`,
    getCompanyStatistics: `${process.env.REACT_APP_BASE_URL}/statistics`,
    projectList: `${process.env.REACT_APP_BASE_URL}/projects`,
    projectData: `${process.env.REACT_APP_BASE_URL}/project`,
    createPandaDoc: `${process.env.REACT_APP_BASE_URL}/reports`,
    financialCalculations: `${process.env.REACT_APP_BASE_URL}/calculator`,
    verifyCompanyLink: `${process.env.REACT_APP_BASE_URL}/company-link`,
    quickbooksAuth: `${process.env.REACT_APP_BASE_URL}/Ouickbooks/authUri`,
    userSettings: `${process.env.REACT_APP_BASE_URL}/admin/settings`,
    gptCategory: `${process.env.REACT_APP_BASE_URL}/openai/category`,
    gptNote: `${process.env.REACT_APP_BASE_URL}/openai/note`,
    gptSearchRate: `${process.env.REACT_APP_BASE_URL}/openai/searchRate`,
    gptSearchCompany: `${process.env.REACT_APP_BASE_URL}/openai/searchCompany`,
    gptSearchReport: "https://us-central1-loyal-framework-352018.cloudfunctions.net/api/api/openai/searchReport",
    sendEmail: `${process.env.REACT_APP_BASE_URL}/sendEmail`,
};

export default apiURL;